// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3i5X0","errorLogs":"styles_errorLogs__3mO78"};